import Yellow_child from "./images/yellow_child.jpg"
import Purple_child from "./images/purple_child.jpg"
import Disco from "./images/disco.jpg"
import Matthew from "./images/matthew_clavane.jpg"
import Cyclist from "./images/cyclist.jpg"
import Twins_yellow from "./images/twins_yellow.jpg"
import Twins_blue from "./images/twins_blue.jpg"

export const figures = [
  {
    id: 0,
    src: Yellow_child,
    alt: "Yellow and child",
    caption: "Fear 2020",
  },
  {
    id: 1,
    src: Purple_child,
    alt: "Purple and child",
    caption: "Fear 2020",
  },
  {
    id: 2,
    src: Cyclist,
    alt: "Cyclist",
    caption: "Cyclist and cat 2019",
  },
  {
    id: 3,
    src: Disco,
    alt: "Disco",
    caption: "дискотека 2020",
  },
  {
    id: 4,
    src: Matthew,
    alt: "Matthew Clavane",
    caption: "Matthew Clavane 2020",
  },
  {
    id: 5,
    src: Twins_yellow,
    alt: "Yellow and twins",
    caption: "Sinä ja minä, kaksin 2020",
  },
  {
    id: 6,
    src: Twins_blue,
    alt: "Blue and twins",
    caption: "Sinä ja minä, kaksin 2020",
  },
]
